import React, { createContext, useContext, useEffect } from 'react';
import { directory } from '../services/Typecode';
import { useHotel } from './HotelContext';
import hotelSpecificTranslation from '../services/translations/hotelSpecificTranslation.json';
import { ConfigProvider } from 'antd';
import ReactGA from 'react-ga4';
import { getHotelFontFamily } from '../helper/hotelFonts';

const LanguageContext = createContext({});
export const useLanguage = () => useContext(LanguageContext);

const LanguageContextProvider = ({ children }) => {
    const [lang, setLang] = React.useState('en');
    const [langList, setLangList] = React.useState([]);
    const [translation, setTranslation] = React.useState({});
    const { hotelDetails } = useHotel();

    React.useEffect(() => {
        const response = localStorage.getItem('lang') || 'en';
        changeHTMLDirection(response);
        setLang(response);
    }, []);
    useEffect(() => {
        if (hotelDetails.languages && hotelDetails.languages.length) {
            const enabledLanguages = hotelDetails.languages?.filter((lang) =>
                Boolean(lang.enabled)
            );
            setLangList(enabledLanguages);
        }
        // if (hotelDetails.languages && hotelDetails.languages.length === 0) {
        //     changeLanguage('en');
        // }
    }, [hotelDetails, hotelDetails.languages]);

    React.useEffect(() => {
        let code = lang ?? 'en';
        changeHTMLDirection(code);
        const getTranslation = directory[code] || {};

        const hotelID = hotelDetails.id;
        const propertyObj = hotelSpecificTranslation[hotelID] || {};
        const selectedLangtranslation = propertyObj[code] || {};
        const finalTranslation = {
            ...getTranslation,
            ...selectedLangtranslation,
        };
        setTranslation(finalTranslation);
    }, [lang, hotelDetails.id]);

    React.useEffect(() => {
        const updateLanguage = () => {
            try {
                const response = localStorage.getItem('lang') || 'en';
                setLang(response);
            } catch (error) {}
        };

        updateLanguage();
    }, []);

    const changeHTMLDirection = (code) => {
        document.body.setAttribute('langcode', code);
        if (code === 'ar') {
            document.body.setAttribute('dir', 'rtl');
        } else {
            document.body.setAttribute('dir', 'ltr');
        }
    };
    // const renderText = (key) => {
    //     const value = translation[key]
    //     return value;
    // };
    const updateLocalStorage = async (lang) => {
        try {
            await localStorage.setItem('lang', lang);
        } catch (error) {}
    };
    const changeLanguage = (language, reloadApp) => {
        setLang(language);
        updateLocalStorage(language);
        ReactGA.set({ language });
        ReactGA.event({
            category: 'language',
            action: 'language_changed',
            label: language,
        });
        if (reloadApp) window.location.reload();
    };

    const hotelFontFamily = getHotelFontFamily(hotelDetails);

    const value = {
        changeLanguage,
        lang,
        langList,
        t: translation,
    };
    return (
        <ConfigProvider
            theme={{
                token: hotelFontFamily
                    ? { fontFamily: hotelFontFamily }
                    : undefined,
                components: {
                    Button: {
                        colorPrimary:
                            hotelDetails.guest_primary_color || '#75716f',
                        algorithm: true, // Enable algorithm
                    },
                    Input: {
                        colorPrimary:
                            hotelDetails.guest_primary_color || '#75716f',
                        algorithm: true, // Enable algorithm
                    },
                },
                hashed: false,
            }}
        >
            <LanguageContext.Provider value={value}>
                {children}
            </LanguageContext.Provider>
        </ConfigProvider>
    );
};

export default LanguageContextProvider;
